/* lua.js generated code 0.3.0 */
require("clover/panel/component/emailPanel/EmailManager")
require("clover/logic/UserMark")
require("clover/data/FreegiftManager")
require("clover/scene/component/homescene/HomeSceneButton")
// require("clover/data/PiggyBankManager")

// var TreasureBoxManager = require("activity/TreasureBox/TreasureBoxManager.js")
let UserNewReward = require("clover/logic/userTask/UserNewReward")
var wSize = cc.Director.getInstance().getWinSize()
var HomeSceneBtnLayer = xClass("HomeSceneBtnLayer", cc.Layer)
var MarkLogic = require("clover/panelBusLogic/MarkLogic")
var ICON_MAX_SIZE = 140
var BOTTOM_ICON_MAX_SIZE = 117
// _G.CHEST_WIDRH = 150
_G.CHEST_WIDRH = 60
_G.BANNER_HEIGHT = 80 + _safe_area_top
const perColumnCount = Math.min( Math.floor(display.height / display.width * 4.35 - 1.72) , 6)
// 按钮位置
const BtnPos = {
    ipad: [{ x: 58, y: 80 }, { x: 155, y: 70 }],
    iphone: [{ x: 58, y: 130 }, { x: 51, y: 270 }],
}

HomeSceneBtnEnum = table(
    [1, "kActivity", 1],
    [1, "kTask", 2],
    [1, "kStar", 3],
    [1, "kMark", 4],
    [1, "kMarket", 5],
    [1, "kShake", 6]
)
HomeSceneBtnPosIndex = table(
    [1, "Right_ActivitiesButton", 1],
    [1, "Right_GameClubButton", 2],
    [1, "Right_CoinDozenBtn", 99],
    [1, "Right_InvitationGiftButton", 3],
    // [1, "Right_WxMoreGameButton", 4],
    [1, "Right_TreasureBoxBtn", 5]
)
//kleft kright 从上到下, kBottom从右到左
const IconPosIndex = {
    [ICON_TYPE.kLeft]: [
        "kNewRankDebug", 
        "kWaterFighting",//水上乐斗
        "kDunkAce",//投篮王牌
        "kSticker",//贴贴大作战
        "kPetStory",//宠物
        "kCircusGame", //马戏团
        "kBuildShip",//造船
        "kChampion", //冠军赛
        "kLightingRush",//萌萌竞速
        "kQualify", //晋级赛
        "kSecretCode",//解码特工队
        "kExcavateFood",//挖宝石
        "kGoldMatch", //夺宝大冒险
        "kSeasideStar", //海滨之星
        "kTimeMode", //限时挑战
        "kShardCollect", //周年庆
        "kStarDream", //星岛梦工厂
        "kSpeedboatMatch",//快艇大赛
        "kFishing",//钓鱼大赛
        "kPickCoco",//摘椰子
        "kNewUserTask", //新手任务
        "kGoldElysium",//金币乐园
        "kRedBag",//星星幸运礼
        "kPvp",// 友谊赛

        "kTetris",//俄罗斯方块放最后
    ],
    [ICON_TYPE.kRight]: [
        "KInteractiveInviteDebug", 
        "kWelfareCenter",//福利中心
        "kAdSkipGiftBag", //免广告礼包
        "kSalvageGift",
        "kNuclear",
        "kMonthTicket", //月票
        "kBattlePass", //通行证
        "kAdTask", //广告任务奖励
        "kPiggyBank", //存钱罐
        "kSpecialShop", //神秘商店
        "kAIPkg", //AI礼包
        "kEndlessTreasure", //无尽宝藏
        "kTrinityGiftBag", //三选一礼包
        "kIslandTreasure", //海岛礼包
        "kLiveGift", //限定礼包
        
    ],
    [ICON_TYPE.kBottom]: [
        "kMarket", 
    ]
    ,
    [ICON_TYPE.kBottomLeft]: [
        "kGameClub", 
        "kNewRank", 
        "kIslandBook", 
    ]
}

HomeSceneBtnLayer.prototype.ctor = function (homeScene) {
    var self = this
    cc.Layer.prototype.ctor.call(self);
    // body
    self.onInit(homeScene)
}
HomeSceneBtnLayer.prototype.onInit = function (homeScene) {
    this.isBusy = false; //公用isBusy 用于防止主界面各个按钮同时点击 导致界面同时弹出

    var self = this

    self.posIndexMap = {}
    for (let key in IconPosIndex) {
        for (let index in IconPosIndex[key]) {
            self.posIndexMap[IconPosIndex[key][index]] = tonumber(index) + 1
        }
    }


    let um = UserManager.getInstance()
    if (window.mini) {
        let model = mini.getSystemInfoSync().model
        self.isIpad = model.indexOf("iPad") >= 0
    } else {
        self.isIpad = false
    }
    if (self.isIpad) {
        _G.BANNER_HEIGHT -= 50
    }

    self.pay30day = null;
    // body
    FrameLoader.loadImageWithPlist("cocos/homeScene.plist")
    if (window.mini && window.mini.getPlatform() == MiniPlatform.tt){
        FrameLoader.loadImageWithPlist("cocos/tt_sidehint.plist")
    }

    if (window.mini && window.mini.getPlatform() == MiniPlatform.ks){
        FrameLoader.loadImageWithPlist("homeicon/lobby_icon_desktop.png");
        FrameLoader.loadImageWithPlist("homeicon/lobby_icon_common_use.png")
    }

    self.container = table()
    self.containerList = table()
    self.homeScene = homeScene
    var leftContainer = cc.Node.create()
    leftContainer.setPosition(ICON_MAX_SIZE / 2, display.height - ICON_MAX_SIZE / 3 * 2 - BANNER_HEIGHT - CHEST_WIDRH)
    self.addChild(leftContainer)
    self.container[ICON_TYPE.kLeft] = leftContainer
    self.containerList[ICON_TYPE.kLeft] = table()
    var rightContainer = cc.Node.create()
    rightContainer.setPosition(display.width - ICON_MAX_SIZE / 2, display.height - ICON_MAX_SIZE / 3 * 2 - BANNER_HEIGHT - CHEST_WIDRH)
    self.addChild(rightContainer)
    self.container[ICON_TYPE.kRight] = rightContainer
    self.containerList[ICON_TYPE.kRight] = table()
    var bottomContainer = cc.Node.create()
    // var bottomContainer = cc.Sprite.createWithSpriteFrameName("homeScene/icon_bar_bg.png")
    // bottomContainer.setPosition(bottomContainer._contentSize.width / 2, bottomContainer._contentSize.height / 2)
    bottomContainer.setPosition(cc.p(ICON_MAX_SIZE / 2, ICON_MAX_SIZE / 2))
    self.addChild(bottomContainer)
    self.container[ICON_TYPE.kBottom] = bottomContainer
    self.containerList[ICON_TYPE.kBottom] = table()

    var bottomLeftContainer = cc.Node.create()
    bottomLeftContainer.setPosition(cc.p(ICON_MAX_SIZE / 2, ICON_MAX_SIZE / 2))
    self.addChild(bottomLeftContainer)
    self.container[ICON_TYPE.kBottomLeft] = bottomLeftContainer
    self.containerList[ICON_TYPE.kBottomLeft] = table()

    var topContainer = cc.Node.create()
    topContainer.setPosition(display.width / 2, display.height - ICON_MAX_SIZE / 2)
    self.addChild(topContainer)
    self.container[ICON_TYPE.kTop] = topContainer
    self.containerList[ICON_TYPE.kTop] = table()
    self.createSideBox()

    let morebtn = cc.Sprite.createWithSpriteFrameName("commonLib/moreiconbtn.png")
    morebtn.setVisible(false)
    morebtn.setPositionY(-perColumnCount * ICON_MAX_SIZE + 20)
    self.container[ICON_TYPE.kLeft].addChild(morebtn)
    self.container[ICON_TYPE.kLeft].morebtn = morebtn
    self.container[ICON_TYPE.kLeft].status = "close"
    quickBuildUIButton(morebtn, ()=>{
        self.showAllBtn(ICON_TYPE.kLeft)
        
    });

    morebtn = cc.Sprite.createWithSpriteFrameName("commonLib/moreiconbtn.png")
    morebtn.setVisible(false)
    morebtn.setPositionY(-perColumnCount * ICON_MAX_SIZE + 20)
    self.container[ICON_TYPE.kRight].addChild(morebtn)
    self.container[ICON_TYPE.kRight].morebtn = morebtn
    self.container[ICON_TYPE.kRight].status = "close"
    quickBuildUIButton(morebtn, ()=>{
        self.showAllBtn(ICON_TYPE.kRight)
        
    });

    //玩吧的活动按钮，子按钮有平台要求的必须显示的，先保留，
    self.createActivitiesButton()
    //self.createGameClubButton()
    
    // star rank
    // self.createQzoneBackgroundBtn()
    //玩吧活动按钮里的‘每日礼包’按钮，跳转到商店的折扣标签 暂时不要
    //if (!UserManager.getInstance().shouldShowLeadAction() && !UserManager.getInstance().shouldShowSurveyAction()) {
        //self.createDiscountShopBtn()
    //}
    //玩吧vip福利按钮 必须显示
    if (UserManager.getInstance().showVipPrivilegesBtn()) {
        self.createVipPrivilegesBtn()
    }
    //创建腾讯视频推广按钮（平台判断在函数里）
    self.createQQLiveBtn()
    
    self.updateSendToDesktopBtn()

    // require('platform/wechatgame/recommender')
    // self.recommender = new Recommender({
    //     appid: 'wxd93fb8bddf971d14',
    //     openid: META.user.openid,
    //     debug: __DEBUG,
    //     env: __DEBUG ? "pre" : "prod"
    // })

    // let isIos = false;
    // if (isWechatGameEnv()) {
    //     let system = mini.getSystemInfoSync().system;
    //     if (system.indexOf("iOS") != 0) 
    //         isIos = true;
    // }

    // // 根据微信运营规范5.10，iOS平台不开放这个按钮 https://developers.weixin.qq.com/miniprogram/product/#5-%E8%A1%8C%E4%B8%BA%E8%A7%84%E8%8C%83
    // if (isIos) {
    //     self.createWxAllPlayButton2(btnIndex++);
    // }  else {
    //     btnIndex ++;
    // } 
    // self.createWxAllPlayButton(btnIndex++);

    // self.createPromoteBtn();
    //self.createCustomAd()
    // self.createMailBtn()
    // self.createUnionBtn()
    // self.createFAQBtn()
    //玩吧加好友按钮
    //self.createFriendBtn()
    // self.createIslandsIcon()

    //self.createQQLiveBtn()
    // 主界面icon统一管理
    //世界聊天正交分组
    CfgManager.load("game").then((data) => {
        // var self = this
        // // body
        // var btn = require("clover/scene/component/homescene/ChatButton").create()
        // self.chatButton = btn
        // // self.addBtnToSelf(btn, ICON_TYPE.kBottom)
        // self.buttonBox.addBtn(btn, BOX_ICON_TYPE.kBottom)

        self.config = CfgManager.get("game");
        // let set = config[settabs]
        // if (set != null && window.minigameCenter){
        //     window.minigameCenter.setTabs(set)
        // }
        CfgManager.release("game");
    }).catch(() => {
        console.log("@@@@chatbtn load game cfg fail");
        CfgManager.release("game");
    });
    // 微信ios的商店涉及到审核，有特殊的标志需要读取
    let isWechatgameIOS = window.mini && mini.getOS() == MiniOS.IOS && mini.getPlatform() == MiniPlatform.wechatGame
    if ((isWechatgameIOS && um.canIconShow("shop_ios_wechatgame")) || (!isWechatgameIOS && um.canIconShow("shop"))) {
        self.createMarketBtn();
    }

    if (window.mini && window.mini.getPlatform() == MiniPlatform.tt){
        self.createRevisitBtn()
        self.createTTDesktopBtn()
    }

    if (window.mini && window.mini.getPlatform() == MiniPlatform.ks){
        self.createDesktopBtn()
        self.createCommonUseBtn();
    }

    if (um.canIconShow("bbs")) {
        self.createGameClubButton()
    }


    UserMark.getInstance().on(UserMark.MarkEvent.Marked, function () {
        self.updateBoxPrompt()
    })

    // self.updatePiggyBankIcon()
    let EmailMgr = EmailManager.getInstance();
    if (!EmailMgr.lastGetInfoTime) {
        EmailMgr.getInfo().then(function (evt) {
            self.updateBoxPrompt()
        })
    }
}

HomeSceneBtnLayer.prototype.onViewChanged = function () {
    let self = this

    self.buttonBox.onViewChanged()

}

HomeSceneBtnLayer.prototype.createUnionBtn = function () {
    let self = this
    let busy = false
    let animClass = require("clover/panel/component/common/uiButtonAnims/HomeSceneBottomBtnAnim")
    self.unionBtn = HomeSceneButton.create("公会", "homeScene/friendicon.png", true, true, PromptTypeDef.noDot, true, animClass)
    self.unionBtn.setAnchorPoint(-0.5, 0)
    self.unionBtn.customInit = function () {
        let delta = -11
        let unionBtn = self.unionBtn
        unionBtn.bg.y = delta
        unionBtn.imageNode.y = delta
        unionBtn.text.y = delta + (-unionBtn.bg._contentSize.height * unionBtn.bg.getScale() + unionBtn.text.getContentSize().height * unionBtn.text.getScale()) / 2
    }
    self.unionBtn.onCick = function () {
        if (busy) {
            return
        }
        busy = true
        Toast.make("功能暂未开放！", 1, () => {
            busy = false
        })
    }
    self.unionBtn.posIndex = 3
    self.addBtnToSelf(self.unionBtn, ICON_TYPE.kBottom, "kUnion")
}
HomeSceneBtnLayer.prototype.createSideBoxContent = function () {
    let self = this
    self.createNameCardBtn() //名片
    self.createBagBtn() //背包
    self.createMailBtn() //消息
    self.createSettingBtn() //设置
    self.createCdKeyBtn()//兑换码
    self.createAddressBtn()//地址
    // FC button

    if (SnsProxy.getInstance().supportCustomerService())
        self.createFCBtn();
    // if (window.switchs.forumSwitch !== ForumSwitch.CLOSE) {
    //     self.createForumBtn()    //部落
    // } 

    self.createCompenBtn() //公告

    // self.createCompenBtn()
    self.createCouponBtn()
    // self.updateFAQBtn()
    self.updateMarkBtn() //签到
    self.createChatGroupBtn() //世界聊天

    const show = MysteryIslandManager.getInstance().isShowExhibitionIcon();
    let count = cc.UserDefault.getInstance().getIntegerForKey("mystery_island_exhibition", 0);
    if(show && count < 3) {
        Toast.make(getText("user_info.guide.tip1"));
        cc.UserDefault.getInstance().setIntegerForKey("mystery_island_exhibition", count + 1);
    }

}
//-也不知道这玩意能不能移动。。先放这吧
HomeSceneBtnLayer.prototype.createSideBox = function () {
    var self = this
    var box = require("clover/scene/component/homescene/HomeSceneButtonBox").create(self)
    self.addChild(box)
    self.buttonBox = box
    self.buttonBox.x = 10
    FreegiftManager.getInstance().on(FreegiftEvents.UpdateMsgNum, function () {
        self.updateBoxPrompt()
    })
}
HomeSceneBtnLayer.prototype.createActivitiesButton = function () {
    if (META.platform == XcloverPlatform.qq || META.platform == XcloverPlatform.weixin || META.platform == XcloverPlatform.he) {
        var self = this
        var icon = require("clover/scene/component/homescene/ActivitiesButton").create(self)
        icon.posIndex = HomeSceneBtnPosIndex.Right_ActivitiesButton
        //TODO:微信公众号平台暂时不显示这个按钮
        if (window.mqq && window.OPEN_DATA.qua.app != 'WX')
            self.addBtnToSelf(icon, ICON_TYPE.kRight, 1)
        self.activitiesButtonIcon = icon    
    }
}

HomeSceneBtnLayer.prototype.createShortcutButton = function () {
    var self = this


    function remove(){
        if (self.GameClubButtonIcon){
            // self.GameClubButtonIcon.removeFromParent()
            self.removeBtnFromSelf(self.GameClubButtonIcon)
            self.GameClubButtonIcon = null

        }

        if (self.gameClubButton) {
            self.gameClubButton.destroy()
            self.gameClubButton = null
        }
    }
    function create(){
        if (self.GameClubButtonIcon) return
        
        var icon = require("clover/scene/component/homescene/GameClubButton").create(self)
        self.addBtnToSelf(icon, ICON_TYPE.kBottomLeft, "kGameClub")
        icon.text.setVisible(false)
    
        self.GameClubButtonIcon = icon
        // self.GameClubButtonIcon.on(UIButtonEvent.Click, () => {
        //     let tips = self.GameClubButtonIcon.getChildByName("tips")
        //     tips && tips.setVisible(false)
        // })
        let fs = cc.director.getOpenGLView().getFrameSize();
        let wSize = cc.Director.getInstance().getWinSize()
        self.gcBtnPos = {}
        self.gcBtnPos.scale = cc.view.getDevicePixelRatio() * fs.width / cc.winSize.width
        var pos = icon.convertToWorldSpace(ccp(0, -7))
    
        var gcBtnWidth = 95;
    
        if (self.gameClubButton) {
            self.gameClubButton.show()
        } else {
            self.gameClubButton = mini.createShortcutButton({
                // icon: 'white',
                style: {
                    left: pos.x * fs.width / wSize.width - gcBtnWidth / 2 - 42,
                    top: (1 - pos.y / wSize.height) * fs.height - gcBtnWidth / 2 - 13,
                    // fontSize : 24
                    width: gcBtnWidth,
                    height: gcBtnWidth
                }
            })

            self.gameClubButton.onTap(function(data){
                if (data.code == 0 || data.code == 1){
                    remove()
                }
            })
        }
    }
    
    mini.hasShortcutInstalled({
        success: function(status) {
            if(status) {
                remove()
            }else{
                create()
            }
        }
    })

}
HomeSceneBtnLayer.prototype.createGameClubButton = function () {
    var self = this
    if (!window.mini || !mini.supportGameClub()) {
        return;
    }

    var icon = require("clover/scene/component/homescene/GameClubButton").create(self)
    // icon.posIndex = HomeSceneBtnPosIndex.Right_GameClubButton
    // self.addBtnToSelf(icon, ICON_TYPE.kRight, 1)
    self.addBtnToSelf(icon, ICON_TYPE.kBottomLeft, "kGameClub")
    // self.buttonBox.addBtn(icon, BOX_ICON_TYPE.kBottom, "kGameClub")
    // icon.setVisible(false)
    self.GameClubButtonIcon = icon
    self.GameClubButtonIcon.on(UIButtonEvent.Click, () => {
        let tips = self.GameClubButtonIcon.getChildByName("tips")
        tips && tips.setVisible(false)
    })
    let fs = cc.director.getOpenGLView().getFrameSize();
    let wSize = cc.Director.getInstance().getWinSize()
    self.gcBtnPos = {}
    self.gcBtnPos.scale = cc.view.getDevicePixelRatio() * fs.width / cc.winSize.width
    var pos = icon.convertToWorldSpace(ccp(0, -7))
    // global.btn = icon 
    // global.pos = pos
    // global.fs = fs
    var gcBtnWidth = 30 * self.gcBtnPos.scale;

    if (self.gameClubButton) {
        self.gameClubButton.show()
    } else {
        self.gameClubButton = mini.createGameClubButton({
            icon: 'white',
            style: {
                left: pos.x * fs.width / wSize.width - gcBtnWidth / 2,
                top: (1 - pos.y / wSize.height) * fs.height - gcBtnWidth / 2 - 4,
                width: gcBtnWidth,
                height: gcBtnWidth
            }
        })
    }
    // global.gameClubButton = self.gameClubButton
}
// HomeSceneBtnLayer.prototype.createWxMoreGameButton = function () {
//     var self = this
//     if (META.platform != XcloverPlatform.wechatgame || _G.kIsNewUser) {
//         return
//     }

//     if (!self.wxMoreGameBtn) {
//         var btn = require("clover/scene/component/homescene/WxMoreGameButton").create()
//         self.wxMoreGameBtn = btn
//         // self.activitiesButtonIcon.addBtn(btn, 99999) // 按钮排最后

//         // btn.posIndex = 3
//         btn.posIndex = HomeSceneBtnPosIndex.Right_WxMoreGameButton
//         self.addBtnToSelf(btn, ICON_TYPE.kRight)
//     }
// }
HomeSceneBtnLayer.prototype.createPromoteBtn = function (pay30day = null) {
    var self = this
    if (__DEV || (global.mini && mini.getPlatform() === MiniPlatform.wechatGame)) {
        if (self.promotButton) {
            return
        }
        self.pay30day = pay30day;
        var promoteConfigs = [];
        CfgManager.load("promot").then((dataMap) => {
            cc.log("createPromoteBtn pay30day", pay30day);
            const config = dataMap.get("promot");
            const uid = parseInt(UserManager.getInstance().uid)
            for (const id in config) {
                const modBase = config[id]['id_mod_base']
                const modValue = config[id]['id_mod_value']
                const beginTime = config[id]['promotion_start']
                const endTime = config[id]['promotion_end']
                const timestemp = Localhost.timeInSec()
                const minLevel = Math.max(0, config[id]['min_stage'])
                const maxLevel = config[id]['max_stage'] < 0 ? Number.MAX_VALUE : config[id]['max_stage']
                const userLevel = UserManager.getInstance().user.topLevelId
                const isOn = config[id]['on'];
                var payType = config[id]['pay_type'];
                if (true || isOn == 1 && timestemp > beginTime && timestemp <= endTime &&
                    userLevel >= minLevel && userLevel <= maxLevel &&
                    uid % modBase == modValue
                    && (payType == -1 || (payType == 1 && self.pay30day) || (payType == 0 && !self.pay30day))) {
                    const promoteCfg = Object.assign({ "promotion_id": id }, config[id])
                    promoteConfigs.push(promoteCfg);
                }
            }
            cc.log("promoteConfigs", promoteConfigs)
            CfgManager.release("promot")
            if (promoteConfigs.length == 0 && self.promotButton) {
                self.promotButton.removeFromParent()
                self.promotButton = null
            }
            if (promoteConfigs.length > 0) {
                const btn = require("clover/scene/component/homescene/PromoteButtton").create(promoteConfigs)
                if (btn != null) {
                    self.promotButton = btn
                    var pos = BtnPos[self.isIpad ? "ipad" : "iphone"][0];
                    btn.setPosition(cc.p(pos.x, pos.y));
                    self.addChild(btn)
                }
            }
            if (!self.promotButton) {
                self.createCustomAd()
            }
        })
    } else {

    }
    // self.updatePromoteBtn()
}

HomeSceneBtnLayer.prototype.updatePromoteBtn = function () {
    // 互导暂时去掉
    // this.pfManager = PromoteFlowManager.getInstance();
    // if (this.pfManager.isOpen() && this.pfManager.checkGetShowArr()) {
    //     cc.log("[Promote Flow]", "HomeSceneBtnLayer.prototype.updatePromoteBtn 符合条件");
    //     if (!this.promotButton) {
    //         const btn = require("clover/scene/component/homescene/PromoteButtton").create()
    //         if (btn != null) {
    //             this.promotButton = btn
    //             var pos = BtnPos[this.isIpad ? "ipad" : "iphone"][0];
    //             btn.setPosition(cc.p(pos.x, pos.y));
    //             this.addChild(btn)
    //         }
    //     } else {
    //         cc.log("[Promote Flow]", "HomeSceneBtnLayer.prototype.updatePromoteBtn 按钮已经存在");
    //     }
    // } else {
    //     if (this.promotButton) {
    //         this.promotButton.removeFromParent()
    //         this.promotButton = null
    //     }
    // }


    // this.createCustomAd()
}
HomeSceneBtnLayer.prototype.createCustomAd = function () {
    var self = this
    let scene = cc.Director.getInstance().getRunningScene();
    let name = "no_name"
    if (scene)
        name = scene.name
    //console.log("@@@@ create custom ad scene ", name)
    if (global.mini) {
        var pos = BtnPos[self.isIpad ? "ipad" : "iphone"][0];
        var snsProxy = require("clover/sns/SnsProxy").getInstance();
        if (this.promotButton) {
            snsProxy.destroyCustomAd();
        } else {
            let systemInfo = mini.getSystemInfoSync()
            snsProxy.showCustomAd({
                //adUnitId:"adunit-367d565488d655e2",
                adIntervals: 60,
                style: {
                    left: 4,
                    top: systemInfo.screenHeight - pos.y,
                    fixed: 0
                }
            }, "custom_homepage", name)
        }
    }
}
HomeSceneBtnLayer.prototype.updateSendToDesktopBtn = function () {
    var self = this
    
    if (
        (
        (META.platform == XcloverPlatform.qq || META.platform == XcloverPlatform.weixin) && 
        window.mqq.data.canIShow('favoritesToDesktop')) || 
        META.platform == XcloverPlatform.he
        ) {
        var level = UserManager.getInstance().getUserRef().getTopLevelId()
        var showButton = level >= 3 // NewUserShortCutPopoutAction也需要改
        if (showButton) {
            self.createSendToDesktopBtn()
            var needGetReward = !UserNewReward.getInstance().isShortCutRewardGet()
            self.sendToDesktopBtn.update(needGetReward)
        } else {
            self.removeSendToDesktopBtn()
        }
    }
}
HomeSceneBtnLayer.prototype.createSendToDesktopBtn = function () {
    var self = this
    if (self.sendToDesktopBtn) {
        return
    }
    var btn = require("clover/scene/component/homescene/SendToDesktopButton2").create(self)
    //NOTE:called only in updateSendToDesktopBtn, do not need platform check
    if (META.platform == XcloverPlatform.qq || META.platform == XcloverPlatform.weixin || META.platform == XcloverPlatform.he){
         let clicked = cc.UserDefault.getInstance().getIntegerForKey("send_to_desktop_icon_clicked")
         if (clicked) {
             btn.inActivitiesPanel = true
             self.activitiesButtonIcon.addBtn(btn)
         } else {
             self.addBtnToSelf(btn, ICON_TYPE.kLeft, 2)
         }
    }else if (META.platform != XcloverPlatform.wechatgame){
        self.addBtnToSelf(btn, ICON_TYPE.kLeft, 2)
    }
    self.sendToDesktopBtn = btn
}
HomeSceneBtnLayer.prototype.removeSendToDesktopBtn = function () {
    var self = this
    if (self.sendToDesktopBtn) {
        self.removeBtnFromSelf(self.sendToDesktopBtn)
        self.sendToDesktopBtn = null;
    }
}

HomeSceneBtnLayer.prototype.updateMarkBtn = function () {
    var self = this
    var level = UserManager.getInstance().getUserRef().getTopLevelId()
    if (level >= MarkLogic.getUnlockLevel()) {
        self.createMarkBtn()
    } else {
        self.removeMarkBtn()
    }
}
//世界聊天
HomeSceneBtnLayer.prototype.createChatGroupBtn = function () {
    var self = this
    // body
    if (self.chatButton || !self.config) {
        return
    }

    let chatGroup = UserManager.getInstance().userLabel.chatGroup
    console.log("@@@@ current chat group " + chatGroup)
    if (chatGroup) {
        if (window.mini && mini.getPlatform() == MiniPlatform.wechatGame && mini.supportWorldChat()) {
            if (mini.getOS() == MiniOS.IOS && UserManager.getInstance().canIconShow("chat_ios_wechatgame")) {
                self.createChatBtn("chat_ios_wechatgame_settabs");
            }//android接入
            else if (mini.getOS() == MiniOS.Android && UserManager.getInstance().canIconShow("chat_android_wechatgame")) {
                self.createChatBtn("chat_android_wechatgame_settabs");

            }
        }

    }
}

HomeSceneBtnLayer.prototype.createMarkBtn = function () {
    var self = this
    // body
    if (self.markButton) {
        return
    }
    var btn = require("clover/scene/component/homescene/MarkButton").create()
    UIUtils.addButtonPrompt(btn, cc.p(30, 25), UserMark.getInstance(), UserMark.MarkEvent.Marked)
    var level = UserManager.getInstance().getUserRef().getTopLevelId()
    btn.updatePrompt((level >= MarkLogic.getUnlockLevel() && UserMark.getInstance().canMark()) ? 1 : 0)
    btn.showNumTxt(false)
    btn.posIndex = 50
    self.buttonBox.addBtn(btn, BOX_ICON_TYPE.kTop2, "kMark")
    self.markButton = btn
}
HomeSceneBtnLayer.prototype.removeMarkBtn = function () {
    var self = this
    if (self.markButton) {
        self.buttonBox.removeBtn(self.markButton, BOX_ICON_TYPE.kTop2)
        self.markButton = null
    }
}
// HomeSceneBtnLayer.prototype.updataCoinDozenBtn = function () {
//     var self = this
//     // if (!__IOS_NOT_AUDIT) {
//     //     return 
//     // }
//     // cc.warn("updataCoinDozenBtn should be restore")
//     //玩吧平台首页必须有分享
//     if (META.platform == XcloverPlatform.wechatgame) {
//         return;
//     }
//     if (UserManager.getInstance().getInviteStatus() <= 0) {
//         return 
//     }
//     var canInvitCount = CoinDozerManager.getInstance().getEmptyInvitableCount()
//     var inviteData = CoinDozerManager.getInstance().getCoinDozerDatasEnabled()
//     if (canInvitCount === 0 && $len(inviteData) === 0) {
//         if (self.coinDozerButton) {
//             // self.activitiesButtonIcon.removeBtn(self.coinDozerButton)
//             self.removeBtnFromSelf(self.coinDozerButton)
//             self.coinDozerButton = null
//         }
//     } else {
//         if (!self.coinDozerButton) {
//             var btn = require("clover/scene/component/homescene/CoinDozerButton").create(self)
//             // self.activitiesButtonIcon.addBtn(btn, 0)
//             // btn.posIndex = 3
//             btn.posIndex = HomeSceneBtnPosIndex.Right_CoinDozenBtn
//             self.addBtnToSelf(btn, ICON_TYPE.kRight, 2)
//             self.coinDozerButton = btn
//         }
//         self.coinDozerButton.update()
//     }
// }
// HomeSceneBtnLayer.prototype.addCoinDozenBtn = function () {
//     return
//     var self = this
//     if (!self.coinDozerButton) {
//         var btn = require("clover/scene/component/homescene/CoinDozerButton").create(self)
//         self.addBtnToSelf(btn, ICON_TYPE.kLeft, 1)
//         self.coinDozerButton = btn
//     }
//     self.coinDozerButton.update()
// }
HomeSceneBtnLayer.prototype.createActivityBtn = function () {
    if (META.platform == XcloverPlatform.qq || META.platform == XcloverPlatform.weixin || META.platform == XcloverPlatform.he){
        var self = this
        var btn = require("clover/scene/component/homescene/ActivityButton").create()
        self.addBtnToSelf(btn, ICON_TYPE.kLeft)
        self.activityButton = btn
    }
}

//玩吧船长任务
/*HomeSceneBtnLayer.prototype.createTaskBtn = function () {
    var self = this
    if(isWechatGameEnv()) {
        return
    }
    if (!self.taskBtn) {
        var btn = require("clover/scene/component/homescene/TaskButton").create()
        self.addBtnToSelf(btn, ICON_TYPE.kLeft)
        self.taskBtn = btn
    }
}*/
// function HomeSceneBtnLayer:createGoldBtn( ... )
// 	-- body
// 	local btn =  require("clover.scene.component.homescene.GoldButton"):create()
// 	self:addBtnToSelf(btn, ICON_TYPE.kRight)
// 	self.goldBtn = btn
// end
HomeSceneBtnLayer.prototype.createMarketBtn = function () {
    var self = this
    // body
    var btn = require("clover/scene/component/homescene/MarketButton").create()
    self.marketButton = btn
    self.addBtnToSelf(btn, ICON_TYPE.kBottom, "kMarket");
}
HomeSceneBtnLayer.prototype.createTTDesktopBtn = function () {
    var self = this
    if (self.ttDesktopBtn){
        return
    }
    console.log("shortcut createShortCut")
    window.mini.checkShortcut({
        success(){
            console.log("shortcut checksuccess")
            var btn = require("clover/scene/component/homescene/TTDesktopButton").create(self, true)
            self.addBtnToSelf(btn, ICON_TYPE.kLeft, 2)
            self.ttDesktopBtn = btn
        },
        fail(res){
            console.log("shortcut checkfailed ",res.errMsg)
        }
    })
}
//将小游戏设为常用
HomeSceneBtnLayer.prototype.createCommonUseBtn = function () {
    var self = this
    if (self.commonUseBtn) {
        return
    }
    cc.log("checkCommonUse start")
    window.mini.checkCommonUse({
        success(res) {
            cc.log("checkCommonUse checksuccess", res)
            if (res && !res.isCommonUse) {//isCommonUse: true 表示已经设为常用 false 表示未设置为常用
                var btn = require("clover/scene/component/homescene/CommonUseButton").create(self, true)
                self.addBtnToSelf(btn, ICON_TYPE.kLeft, 3)
                self.commonUseBtn = btn
            }
        },
        fail(err) {
            cc.log("checkCommonUse checkfailed ", err)
        }
    })
}
//创建桌面快捷入口
HomeSceneBtnLayer.prototype.createDesktopBtn = function () {
    var self = this
    if (self.desktopBtn){
        return
    }
    console.log("shortcut createShortCut")
    window.mini.checkShortcut({
        success(){
            console.log("shortcut checksuccess")
            var btn = require("clover/scene/component/homescene/DesktopButton").create(self, true)
            self.addBtnToSelf(btn, ICON_TYPE.kLeft, 2)
            self.desktopBtn = btn
        },
        fail(err){
            console.log("shortcut checkfailed ", err)
        }
    })
}

HomeSceneBtnLayer.prototype.createRevisitBtn = function () {
    var self = this
    if (self.revisitButton){
        return
    }
    console.log("[tt] revisit call createbtn")
    window.mini.checkScene({
        scene:"sidebar",
        success:(res)=>{
            console.log("[tt] revisit check scene success ",res)
            let http = DouyinSideRewardsDetailHttp.new()
            http.addEventListener(Events.kComplete, (evt)=>{
                console.log("[tt] rrevisit createRevisitButton")
                let recTime = evt.data.recTime
                let rewards = evt.data.rewards
                var btn = require("clover/scene/component/homescene/RevisitButton").create(recTime, rewards)
                self.revisitButton = btn
                self.addBtnToSelf(btn, ICON_TYPE.kLeft, "kRevisitBtn")
            })
            http.addEventListener(Events.kError, (evt) => {
                Toast.make(quickGetErrorText(evt.data, getText("error.tip.load_res_error")))
            })
            http.addEventListener(Events.kCancel, (evt) => {
                Toast.make(quickGetErrorText( evt.data, getText("error.tip.load_res_error")))
            })
            http.load()
        },
        fail:(res)=>{
            
            console.log("revisit check scene failed %s",res.errMsg)
        }
    })
}
HomeSceneBtnLayer.prototype.createChatBtn = function (settabs) {
    // CfgManager.load("game").then((data) => {
    var self = this
    // body
    var btn = require("clover/scene/component/homescene/ChatButton").create()
    self.chatButton = btn
    // self.addBtnToSelf(btn, ICON_TYPE.kBottom)
    btn.posIndex = 20
    self.buttonBox.addBtn(btn, BOX_ICON_TYPE.kBottom, "kChat")

    var config = self.config;
    let set = config[settabs]
    if (set != null && window.minigameCenter) {
        window.minigameCenter.setTabs(set)
    }
    //     CfgManager.release("game");
    // }).catch(() => {
    //     console.log("@@@@chatbtn load game cfg fail");
    //     CfgManager.release("game");
    // });


}
HomeSceneBtnLayer.prototype.createShakeBtn = function () { }
HomeSceneBtnLayer.prototype.createFriendBtn = function () { }
//下面的按钮先放到盒子里
HomeSceneBtnLayer.prototype.createBagBtn = function () {
    var self = this
    if (self.bagBtn) {
        return
    }
    var btn = require("clover/scene/component/homescene/BagButton").create()
    btn.posIndex = 20
    self.buttonBox.addBtn(btn, BOX_ICON_TYPE.kTop2, "kBag")
    self.bagBtn = btn
}
HomeSceneBtnLayer.prototype.createMailBtn = function () {
    var self = this
    if (self.emailBtn) {
        self.emailBtn.updatePrompt();
        return
    }
    var btn =  require("clover/panel/component/emailPanel/EmailBtn").create()
    btn.posIndex = 30
    self.buttonBox.addBtn(btn, BOX_ICON_TYPE.kTop2, "kMail")
    self.emailBtn = btn;
}
HomeSceneBtnLayer.prototype.createCompenBtn = function () {
    var self = this
    if (self.compenBtn) {
        return
    }
    var btn = require("clover/scene/component/homescene/CompenButton").create()
    self.compenBtn = btn
    btn.posIndex = 40
    self.buttonBox.addBtn(btn, BOX_ICON_TYPE.kTop2, "kCompen")
}
HomeSceneBtnLayer.prototype.createSettingBtn = function () {
    var self = this
    // body
    if (self.settingBtn) {
        return
    }
    var btn = require("clover/scene/component/homescene/SettingButton").create()
    btn.posIndex = 40
    self.buttonBox.addBtn(btn, BOX_ICON_TYPE.kBottom, "kSetting")
    self.settingBtn = btn
}

HomeSceneBtnLayer.prototype.createCdKeyBtn = function () {
    var self = this
    if (!CdKeyManager.getInstance().isOpen()) {
        return
    }
    // body
    if (self.cdkeyBtn) {
        return
    }
    var btn = require("clover/scene/component/homescene/CdKeyButton").create()
    btn.posIndex = 40
    self.buttonBox.addBtn(btn, BOX_ICON_TYPE.kBottom, "kCdKey")
    self.cdkeyBtn = btn
}
HomeSceneBtnLayer.prototype.createAddressBtn = function () {
    var self = this
    // body
    if (self.addressBtn) {
        return
    }
    var btn = require("clover/scene/component/homescene/AddressButton").create()
    btn.posIndex = 40
    self.buttonBox.addBtn(btn, BOX_ICON_TYPE.kBottom, "kAddress")
    self.addressBtn = btn
}
HomeSceneBtnLayer.prototype.createCouponBtn = function () { }
HomeSceneBtnLayer.prototype.createNameCardBtn = function () {
    var self = this
    // body
    if (self.nameCardBtn) {
        return
    }
    var btn = require("clover/scene/component/homescene/NameCardButton").create()
    btn.posIndex = 10
    self.buttonBox.addBtn(btn, BOX_ICON_TYPE.kTop2, "kNameCard")
    self.nameCardBtn = btn
}
HomeSceneBtnLayer.prototype.createFCBtn = function () {
    var self = this
    if (self.fcBtn) {
        return
    }
    if (window.mini && mini.getPlatform() == MiniPlatform.tt){
        let info = mini.getSystemInfoSync()
        console.log("[tt] appName"+info.appName)
        if (info.appName == "Douyin" || info.appName == "douyin_lite" || info.appName == "devtools"){
            // 抖音小游戏且宿主app是抖音的创建IM客服入口
            var btn = require("clover/scene/component/homescene/TTDouyinFAQButton").create()
            btn.posIndex = 30
            self.buttonBox.addBtn(btn, BOX_ICON_TYPE.kBottom, "kFC")
            self.fcBtn = btn
        }
    }else{
        var btn = require("clover/scene/component/homescene/ServiceButton").create()
        btn.posIndex = 30
        self.buttonBox.addBtn(btn, BOX_ICON_TYPE.kBottom, "kFC")
        self.fcBtn = btn
    }
}
HomeSceneBtnLayer.prototype.createQQLiveBtn = function (){
    let self = this
    if ((window.mqq && Object.keys(mqq).length && window.OPEN_DATA.qua.app == 'QQLive')
        /*|| META.platform == XcloverPlatform.he*/)
    {
        let qqLiveConfig = require("activity/QQLive/QQLiveConfig")
        if (!qqLiveConfig.inited) {
            ResManager.load("meta/activity/qqlive_layout.json").then(() => {
                qqLiveConfig.init(ResManager.get("meta/activity/qqlive_layout.json"))
                self.crateQQLiveBtnInternal(qqLiveConfig.icon.resList)
                })
        }else{
            self.crateQQLiveBtnInternal(qqLiveConfig.icon.resList)
        }
    }
}
HomeSceneBtnLayer.prototype.crateQQLiveBtnInternal = function(resList){
    let self = this
    console.log(resList)
    preloadWithLoading(resList, () => {    
        console.log("load finish")
        self.qqLiveBtn = require("activity/QQLive/QQLiveIcon").create()
        self.addBtnToSelf(self.qqLiveBtn, ICON_TYPE.kRight)
    }, null, null, false);
}
HomeSceneBtnLayer.prototype.createForumBtn = function () {
    var self = this
    if (self.forumBtn) {
        return
    }
    if (
        META.platform == XcloverPlatform.he || 
        ((META.platform == XcloverPlatform.qq || META.platform == XcloverPlatform.weixin) && window.mqq.data.canIShow('buluo'))
        ) {
        // body
        var btn = require("clover/scene/component/homescene/ForumBtn").create()
        // self.addBtnToSelf(btn, ICON_TYPE.kBottom)
        btn.posIndex = 30
        self.buttonBox.addBtn(btn, BOX_ICON_TYPE.kBottom, "kForum")
        self.forumBtn = btn
    }
}
HomeSceneBtnLayer.prototype.updateStarLevelBtn = function () {
    let self = this

}

HomeSceneBtnLayer.prototype.createStarLevelBtn = function () {
    let self = this
}

HomeSceneBtnLayer.prototype.createFAQBtn = function () {
    var self = this
    if (META.platform == XcloverPlatform.h4399
         || META.platform == XcloverPlatform.oppo_h5 ||
         META.platform == XcloverPlatform.wechatgame
         || !SnsProxy.getInstance().supportCustomerService()) {
        return
    }
    if (self.FAQBtn) {
        return 
    }
    // body
    var btn = require("clover/scene/component/homescene/FAQButtion").create()
    btn.posIndex = 6
    self.addBtnToSelf(btn, ICON_TYPE.kBottom)
    // self.buttonBox.addBtn(btn, true)
    self.FAQBtn = btn
}
HomeSceneBtnLayer.prototype.removeFAQBtn = function () {
    var self = this
    if (self.FAQBtn) {
        self.buttonBox.removeBtn(self.FAQBtn, true)
        self.FAQBtn = null
    }
}
HomeSceneBtnLayer.prototype.updateFAQBtn = function() {
    var self = this
    var level = UserManager.getInstance().getUserRef().getTopLevelId()
    var unLockLevelOfFAQBtn = 0
    if (level >= unLockLevelOfFAQBtn) {
        self.createFAQBtn()
    } else {
        self.removeFAQBtn()
    }
}
HomeSceneBtnLayer.prototype.createIslandsIcon = function () {
    require("clover/scene/component/IslandsSystem/IslandsLogic").getInstance().showIcon()
}
HomeSceneBtnLayer.prototype.createTreasureBoxBtn = function () {
    let self = this
    // 后端控制icon显示
    // 抖音因为分享问题精力红包在配置里关闭
    if (window.mini && mini.getPlatform() == MiniPlatform.tt) {
        if (UserManager.getInstance().canIconShow("redbag_douyingame") == false) {
            return
        }
    }
    if (!UserManager.getInstance().canIconShow("redbag")) {
        return
    }
    // return
    if (UserManager.getInstance().getUserRef().getTopLevelId() <= 30) {
        return
    }
    if (self.treasureBoxBtn) {
        return
    }
    require.ensure([], () => {
        var TreasureBoxManager = require("activity/TreasureBox/TreasureBoxManager.js")
        TreasureBoxManager.getInstance().getInfo(function () {
            if (TreasureBoxManager.getInstance().isOpen()) {
                const Event = require("hecore/EventDispatcher").Event;
                GlobalEventDispatcher.getInstance().dispatchEvent(Event.new(kGlobalEvents.kWelfareCenterAction,
                    {
                        id: WelfareCenterId.treasureBox,
                        redDot: TreasureBoxManager.getInstance().isHaveReward() || false,
                    }))
                return;
                if (self.treasureBoxBtn == null) {
                    let btn = require("activity/TreasureBox/TreasureBoxButton.js").create()
                    // btn.posIndex = 4
                    // btn.posIndex = HomeSceneBtnPosIndex.Right_TreasureBoxBtn
                    // self.addBtnToSelf(btn, ICON_TYPE.kRight)
                    btn.posIndex = 20
                    self.buttonBox.addBtn(btn, BOX_ICON_TYPE.kTop1, "kTreasureBox")
                    self.treasureBoxBtn = btn
                }
            }
        })
    }, null, 'act')

}



HomeSceneBtnLayer.prototype.updateTreasureBoxBtn = function () {
    let self = this
    // return
    if (self.treasureBoxBtn != null) {
        self.treasureBoxBtn.refresh()
    }
}
HomeSceneBtnLayer.prototype.createQzoneBackgroundBtn = function () {
    if (!__CUT_SIZE) {
        var self = this
        var btn = require("clover/scene/component/homescene/QzoneBackgroundButton").create()
        self.qzoneBackgroundBtn = btn
        self.addBtnToSelf(btn, ICON_TYPE.kLeft)
    }
}
// HomeSceneBtnLayer.prototype.createDiscountShopBtn = function () {
//     var self = this
//     var btn = require("clover/scene/component/homescene/DiscountShopButton").create()
//     self.discountShopBtn = btn
//     self.activitiesButtonIcon.addBtn(btn, 2)
// }
HomeSceneBtnLayer.prototype.createVipPrivilegesBtn = function () {
    var self = this
    if (
        (META.platform == XcloverPlatform.qq || META.platform == XcloverPlatform.weixin) &&
        window.mqq.data.canIShow('miniGameVIP')
        )
        {
            var btn = require("clover/scene/component/homescene/VipPrivilegesButton").create()
            self.vipPrivilegesBtn = btn
            self.activitiesButtonIcon.addBtn(btn)
        }
}
HomeSceneBtnLayer.prototype.getButtonPosition = function (btnType) {
    var self = this
    //change to enum
    if (btnType === HomeSceneBtnEnum.kTask) {
        cc.log(self.taskBtn.getPosition())
        // WARN: maybe multi result
        return self.container[ICON_TYPE.kLeft].convertToWorldSpace(cc.p(self.taskBtn.getPosition()))
    } else {
        // WARN: maybe multi result
        return cc.p(0, 0)
    }
}
HomeSceneBtnLayer.prototype.update = function () {
    var self = this
    let um = UserManager.getInstance()
    // self.updateMarkBtn()
    self.updateFAQBtn()
    if (self.markButton) {
        self.markButton.updatePrompt(UserMark.getInstance().canMark() ? 1 : 0)
    }
    // self.updateFAQBtn()
    self.updateSendToDesktopBtn()
    self.updateTreasureBoxBtn()
    // self.updatePromoteBtn()
    cc.warn("updateShakeBtn should be restore")
    // self.updateShakeBtn()
    // self.updateTaskBtn()

    // if (self.friendBtn) {
    //     self.friendBtn.updatePrompt(um.getGiftMsgNum())
    // }
    self.updateBoxPrompt()

    self.OneStepBtn && self.OneStepBtn.update()
    self.TimeModeIcon && self.TimeModeIcon.update()
    self.CoinMatch && self.CoinMatch.update()
    self.GoldMatchIcon && self.GoldMatchIcon.update()
    // self.RescueMissionBtn && self.RescueMissionBtn.update()

    if (window.mini && window.mini.getPlatform() == MiniPlatform.vivo){
        self.createShortcutButton()
    }
}
HomeSceneBtnLayer.prototype.setInteractiveInviteButtonPrompt = function (show) {
    var self = this
    self.interactiveInviteButtonPrompt = show
}
HomeSceneBtnLayer.prototype.updateBoxPrompt = function () {
    var self = this
    //  检查是否显示签到红点
    var level = UserManager.getInstance().getUserRef().getTopLevelId()
    var showPrompt = (level >= MarkLogic.getUnlockLevel() && UserMark.getInstance().canMark()) ? 1 : 0
    console.log("prompt 签到", showPrompt)
    showPrompt = cc.UserDefault.getInstance().getBoolForKey("_shown_new_icon_box_", false) ? showPrompt : 1
    console.log("prompt 显示过", cc.UserDefault.getInstance().getBoolForKey("_shown_new_icon_box_"), cc.UserDefault.getInstance().getBoolForKey("_shown_new_icon_box_", false))
    //免费礼物红点
    showPrompt = showPrompt || self.interactiveInviteButtonPrompt
    console.log("prompt 免费礼物", self.interactiveInviteButtonPrompt)
    let device = getDeviceInfo()
    if (parseInt(device.quality) > 24){
        console.log("prompt 设置动画效果引导 大于24不需要")
    }else{
        var settingBtnShowGameEffectLevelGuide = (UserLocalSettings.getSetting("GameEffectLevelGuide") != 1)
        showPrompt = showPrompt || settingBtnShowGameEffectLevelGuide
        console.log("prompt 设置动画效果引导", settingBtnShowGameEffectLevelGuide)
    }

    showPrompt = showPrompt || UserManager.getInstance().isShowStickerTip()
    console.log("prompt 贴贴手账簿", showPrompt)
    showPrompt = showPrompt || DressManager.getInstance().getNewDressTipList().length > 0
    console.log("prompt 装扮", showPrompt)

    showPrompt = showPrompt || EmailManager.getInstance().hasRedDot();

    self.buttonBox.setMessageCount(showPrompt) //UserManager.getInstance().getChallengeMsgNum()
    self.buttonBox.setPromptLabelVisible(false)

    if (self.settingBtn) {
        self.settingBtn.updatePrompt()
    }
    if (self.nameCardBtn) {
        self.nameCardBtn.updateDot()
    }
}
HomeSceneBtnLayer.prototype.updateShakeBtn = function () {
    var self = this
    // body
    if (ShakeManager.getInstance().isShakeUnlocked()) {
        if (!self.shakeBtn) {
            self.createShakeBtn()
        }
        ShakeManager.getInstance().updateMskNum()
    }
}
//HomeSceneBtnLayer.prototype.updateTaskBtn = function () {
    // var self = this
    // if (UserTask.getInstance().checkShowTaskButton()) {
    //     self.createTaskBtn()
    // }
//}
HomeSceneBtnLayer.prototype.updateNewTeamGetStarBtn = function () {
    let self = this
    // let Button = require("clover/scene/component/homescene/NewTeamGetStarButton")
    Button.updateShowState()
}
//-------------------------
//添加btn
//-------------------------
HomeSceneBtnLayer.prototype.addBtnToSelf = function (btn, posType, name) {
    var self = this
    // body
    assert(btn)
    posType = posType || ICON_TYPE.kRight
    self.container[posType].addChild(btn)
    // if (index) {
    //     table.insert(self.containerList[posType], 1, btn)
    // } else {
    table.insert(self.containerList[posType], btn)
    // }
    btn.posIndex = self.posIndexMap[name] || 999
    btn.orderName = name
    console.log(btn.posIndex, "btnpos", posType, name, self.posIndexMap)
    self.reOrderBtnContainer(posType)
}
HomeSceneBtnLayer.prototype.reomveBtnByTag = function (tagId) {
    var self = this
    if (tagId) {
        var $limit61 = $len(self.containerList)
        for (var k = 1; k <= $limit61; k += 1) {
            for (var i = 1, v = self.containerList[k][1]; v; i++, v = self.containerList[k][i]) {
                if (v.getTag() === tagId) {
                    table.remove(self.containerList, i)
                    v.removeFromParent(true)
                    self.reOrderBtnContainer(k)
                    return
                }
            }
        }
    }
}
//-------------------------
//删除btn
//-------------------------
HomeSceneBtnLayer.prototype.removeBtnFromSelf = function (btn) {
    var self = this
    var $limit67 = $len(self.containerList)
    for (var k = 1; k <= $limit67; k += 1) {
        for (var i = 1, v = self.containerList[k][1]; v; i++, v = self.containerList[k][i]) {
            if (v === btn) {
                table.remove(self.containerList[k], i)
                btn.removeFromParent(true)
                self.reOrderBtnContainer(k)
                return
            }
        }
    }
}
HomeSceneBtnLayer.prototype.showAllBtn = function (posType) {
    var self = this
    if (self.container[posType].status != "close") return
    self.container[posType].status = "running"
    for (var k in self.containerList[posType]) {
        var v = self.containerList[posType][k]
        if (!v.alwaysShow){
            v.setScale(0)
            // v.node.setCascadeOpacityEnabled(true)
            // v.node.setOpacity(0)
            v.setVisible(true)
            v.stopAllActions()
            v.runAction(cc.Sequence.create(
                cc.DelayTime.create(0.05 * ($len(self.containerList[posType]) - k)),
                // cc.CallFunc.create(function () {
                //     self.whiteNode.setVisible(true);
                // }),
                cc.ScaleTo.create( 0.1, 1),
                // cc.FadeIn.create(1)
            ))
            // console.log("delay",k, v.orderName,  0.1 * ($len(self.containerList[posType]) - k))
        }
        
        
    }


    if (!self.container[posType].bubble){
        let bubble = sp.SkeletonAnimation.create("cocos/tbzd.skel","cocos/tbzd.atlas",1)
        bubble.setPosition(self.container[posType].morebtn.x , self.container[posType].morebtn.y)
        // bubble.setAnchorPoint(0, 0)
        bubble.setScaleX(posType == ICON_TYPE.kLeft? 1 : -1)
        self.container[posType].addChild(bubble)
        self.container[posType].bubble = bubble
        bubble.setZOrder(perColumnCount)
    }


    // let height = ($len(self.containerList[posType]) - perColumnCount ) * ICON_MAX_SIZE + 40

    let bubble = self.container[posType].bubble
    let num = $len(self.containerList[posType]) - perColumnCount
    bubble.setAnimation(0, num + "_in", false)
    bubble.setVisible(true)
    bubble.registerSpineEventHandler((trackIndex)=>{
        bubble.setAnimation(0, num + "_idle", false)
        bubble.unregisterSpineEventHandler(3);
        self.container[posType].status = "open"
    },sp.ANIMATION_EVENT_TYPE.COMPLETE)

}

HomeSceneBtnLayer.prototype.hidePartBtn = function (posType) {
    var self = this

    function hide(k, v){
        v.stopAllActions()
        v.runAction(cc.Sequence.create(
            cc.DelayTime.create(0.05 * ( k - perColumnCount) ),
            cc.ScaleTo.create(0.1, 0),
            cc.CallFunc.create(function () {
                if (!v.alwaysShow){
                    v.setVisible(false);
                }
            }),
        ))
    }
    if (self.container[posType].status != "open") return
    self.container[posType].status = "running"
    for (var k in self.containerList[posType]) {
        var v = self.containerList[posType][k]
        if (!v.alwaysShow ){
            hide(k, v)
            // console.log("delay2",k, v.orderName, posType, (0.1 * ( k - 1 - perColumnCount)))
        }
        
    }


    let bubble = self.container[posType].bubble
    if (bubble){
        let num = $len(self.containerList[posType]) - perColumnCount
        bubble.setAnimation(0, num + "_out", false)
    
        bubble.registerSpineEventHandler((trackIndex)=>{
            bubble.unregisterSpineEventHandler(3);
             self.container[posType].status = "close"
             bubble.setVisible(false)
        },sp.ANIMATION_EVENT_TYPE.COMPLETE)
    }




}

//-------------------------
//重新排列
//-------------------------
HomeSceneBtnLayer.prototype.reOrderBtnContainer = function (posType) {
    var self = this
    // body
    let bottomPosy = 15
    if (__IPHONEX) {
        bottomPosy = 35
    }
   
    table.nonNativeSort(self.containerList[posType], function (a, b) {
        // body
        var a_index = a.posIndex || 999
        var b_index = b.posIndex || 999
        if (a_index < b_index) {
            return true
        }
    })
    let len = $len(self.containerList[posType])
    // let delta = len % 2 === 0 ? -BOTTOM_ICON_MAX_SIZE / 2 : 0
    if (posType === ICON_TYPE.kBottom) {
        for (var k in self.containerList[posType]) {
            var v = self.containerList[posType][k]
            // FIXME: wait right order
            if (k === "#") {
                continue
            }
            if (v.orderName == "kGameClub") { //游戏圈按posindex固定位置
                v.setPosition(wSize.width - v.posIndex * BOTTOM_ICON_MAX_SIZE - 22, bottomPosy)
            } else {
                v.setPosition(wSize.width - k * BOTTOM_ICON_MAX_SIZE - 22, bottomPosy)
            }

            // v.setPosition(wSize.width - k * BOTTOM_ICON_MAX_SIZE, 95)
            // v.setPosition(wSize.width / 2 + (k - Math.ceil(len / 2)) * BOTTOM_ICON_MAX_SIZE - v._contentSize.width / 2 + delta, 90)
        }
    }else if(posType === ICON_TYPE.kBottomLeft){
        for (var k in self.containerList[posType]) {
            var v = self.containerList[posType][k]
            // FIXME: wait right order
            if (k === "#") {
                continue
            }
            // if (v.orderName == "kGameClub") { //游戏圈按posindex固定位置
            //     v.setPosition(wSize.width - v.posIndex * BOTTOM_ICON_MAX_SIZE - 40, bottomPosy)
            // } else {
            // }
            v.setPosition((k-1) * BOTTOM_ICON_MAX_SIZE + 0, bottomPosy)

            // v.setPosition(wSize.width - k * BOTTOM_ICON_MAX_SIZE, 95)
            // v.setPosition(wSize.width / 2 + (k - Math.ceil(len / 2)) * BOTTOM_ICON_MAX_SIZE - v._contentSize.width / 2 + delta, 90)
        }
    } else if (posType === ICON_TYPE.kLeft || posType === ICON_TYPE.kRight){
        for (var k in self.containerList[posType]) {
            var v = self.containerList[posType][k]
            v.stopAllActions()
            if ( k <= perColumnCount){

                v.setPosition(0, -(k - 1) * ICON_MAX_SIZE)
                v.alwaysShow = true
                self.container[posType].morebtn.setVisible(false)
                v.setScale(1)
                v.setVisible(true)
            }else {
                // v.setPositionY(-((k - perColumnCount) - 1) * ICON_MAX_SIZE)
                v.setPositionX(posType === ICON_TYPE.kLeft ? 140 : -140)
                v.setPositionY(-((perColumnCount - ($len(self.containerList[posType]) - k) ) - 1) * ICON_MAX_SIZE - 55)
                v.alwaysShow = false
                v.setVisible(false)
                self.container[posType].bubble &&  self.container[posType].bubble.setVisible(false)
                self.container[posType].status = "close"
                self.container[posType].morebtn.setVisible(true)
                
            }
            v.setZOrder(tonumber( k))
        }
    }else {
        for (var k in self.containerList[posType]) {
            var v = self.containerList[posType][k]
            v.setPositionY(-(k - 1) * ICON_MAX_SIZE)
        }
    }
}
HomeSceneBtnLayer.prototype.onStarGroupOpen = function () {
    var self = this
    self.leftBtnsScale = table()
    for (var k in self.containerList[ICON_TYPE.kLeft]) {
        var v = self.containerList[ICON_TYPE.kLeft][k]
        var actionList = table()
        self.leftBtnsScale.push([v.getScaleX(), v.getScaleY()])
        table.insert(actionList, cc.ScaleTo.create(5 / 30, 0))
        table.insert(actionList, cc.CallFunc.create(function () {
            v.setVisible(false)
        }))
        v.runAction(cc.Sequence.create(actionList))
    }
    self.rightBtnsScale = table()
    for (var k in self.containerList[ICON_TYPE.kRight]) {
        var v = self.containerList[ICON_TYPE.kRight][k]
        var actionList = table()
        self.rightBtnsScale.push([v.getScaleX(), v.getScaleY()])
        table.insert(actionList, cc.ScaleTo.create(5 / 30, 0))
        table.insert(actionList, cc.CallFunc.create(function () {
            v.setVisible(false)
        }))
        v.runAction(cc.Sequence.create(actionList))
    }
    for (var k in self.containerList[ICON_TYPE.kBottom]) {
        var v = self.containerList[ICON_TYPE.kBottom][k]
        var actionList = table()
        table.insert(actionList, cc.ScaleTo.create(5 / 30, 0))
        table.insert(actionList, cc.CallFunc.create(function () {
            v.setVisible(false)
        }))
        v.runAction(cc.Sequence.create(actionList))
    }
    var actionList = table()
    table.insert(actionList, cc.MoveBy.create(5 / 30, cc.p(80, 0)))
    table.insert(actionList, cc.CallFunc.create(function () {
        self.buttonBox.setVisible(false)
    }))
    self.buttonBox.runAction(cc.Sequence.create(actionList))
}
HomeSceneBtnLayer.prototype.onStarGroupClose = function () {
    var self = this
    for (var k in self.containerList[ICON_TYPE.kLeft]) {
        var v = self.containerList[ICON_TYPE.kLeft][k]
        var actionList = table()
        table.insert(actionList, cc.CallFunc.create(function () {
            v.setVisible(true)
        }))
        let scale = self.leftBtnsScale[k] || [1, 1]
        table.insert(actionList, cc.ScaleTo.create(5 / 30, scale[0], scale[1]))
        v.runAction(cc.Sequence.create(actionList))
    }
    for (var k in self.containerList[ICON_TYPE.kRight]) {
        var v = self.containerList[ICON_TYPE.kRight][k]
        var actionList = table()
        table.insert(actionList, cc.CallFunc.create(function () {
            v.setVisible(true)
        }))
        let scale = self.rightBtnsScale[k] || [1, 1]
        table.insert(actionList, cc.ScaleTo.create(5 / 30, scale[0], scale[1]))
        v.runAction(cc.Sequence.create(actionList))
    }
    for (var k in self.containerList[ICON_TYPE.kBottom]) {
        var v = self.containerList[ICON_TYPE.kBottom][k]
        var actionList = table()
        table.insert(actionList, cc.CallFunc.create(function () {
            v.setVisible(true)
        }))
        table.insert(actionList, cc.ScaleTo.create(5 / 30, 1))
        v.runAction(cc.Sequence.create(actionList))
    }
    var actionList = table()
    table.insert(actionList, cc.CallFunc.create(function () {
        self.buttonBox.setVisible(true)
    }))
    table.insert(actionList, cc.MoveBy.create(5 / 30, cc.p(-80, 0)))
    self.buttonBox.runAction(cc.Sequence.create(actionList))
}

// // 抖音小游戏且宿主app不是抖音的用这个（比如头条，番茄）
// HomeSceneBtnLayer.prototype.ttCreateFAQBtn = function () {
//     var self = this;

//     var pos = self.settingBtn.getPosition();
//     pos = self.buttonBox.convertToWorldSpace(pos);
//     console.log(pos)
//     let fs = cc.director.getOpenGLView().getFrameSize();
//     let wSize = cc.Director.getInstance().getWinSize()

//     var btn = mini.createContactButton({
//         type: "image",
//         image: "assets/faq_img.png",
//         style: {
//             left: (pos.x - 110) * fs.width / wSize.width,
//             top: (1 - (pos.y + 30) / wSize.height) * fs.height,
//             width: 30,
//             height: 34,
//             lineHeight: 40,
//             backgroundColor: "#ffffff00",
//             textAlign: "center",
//             fontSize: 16,
//             borderRadius: 4,
//             borderColor: "#ffffff00",
//             borderWidth: 0,
//             textColor: "#ffffff00"
//         },
//         success(res) {
//             console.log("create FAQBtn success", res);
//         },
//         fail(res) {
//             console.log("create FAQBtn fail", res);
//         },
//         complete(res) {
//             console.log("create FAQBtn complete", res);
//         }
//     });

//     self.ttFAQBtn = btn;

//     // 点击事件
//     function handleClick() {
//         console.log("点击客服按钮");
//     }

//     btn.onTap(handleClick); // 兼听点击事件

//     btn.show(); // 显示按钮
//     // btn.hide();

//     // 错误处理
//     function handleError(res) {
//         console.log(res.errMsg);
//     }

//     btn.onError(handleError); // 监听错误
// }

// // 抖音小游戏且宿主app不是抖音的用这个（比如头条，番茄）
// HomeSceneBtnLayer.prototype.ttShowFAQBtn = function () {
//     console.log("ttShowFAQBtn")
//     var self = this;

//     if (self.ttFAQBtn) {
//         self.ttFAQBtn.show();
//     } else {
//         self.ttCreateFAQBtn();
//     }
// }

// HomeSceneBtnLayer.prototype.ttHideFAQBtn = function () {
//     console.log("ttHideFAQBtn")
//     var self = this;
//     if (self.ttFAQBtn)
//         self.ttFAQBtn.hide();
// }

// 更新存钱罐入口信息
HomeSceneBtnLayer.prototype.updatePiggyBankIcon = function () {
    let self = this
    let show = PiggyBankManager.getInstance().canShow()
    if (self.piggyBankNewBtn) {
        if (!show) {
            self.removeBtnFromSelf(self.piggyBankNewBtn)
            self.piggyBankNewBtn = null
        } else {
            self.piggyBankNewBtn.tryUpdateIcon()
        }
    } else if (show) {
        // let onResLoad = function (){
        //     self.piggyBankNewBtn = PiggyBankManager.getInstance().createIcon(self)
        //     self.addBtnToSelf(self.piggyBankNewBtn, ICON_TYPE.kRight) //kRight kLeft
        // }
        // let PiggyBankNewIcon = require("clover/panel/piggyBankNew/PiggyBankNewIcon")
        // PiggyBankNewIcon.preloadRes(onResLoad);
        PiggyBankManager.getInstance().createIcon(self)
    }
}
HomeSceneBtnLayer.prototype.clearPiggyBankIconInterval = function () {
    let self = this
    if (self.piggyBankNewBtn) self.piggyBankNewBtn.clearLastTimeInterval();
}
// 更新海滨之星入口信息
HomeSceneBtnLayer.prototype.updateSeasideStarIcon = function () {
    let self = this
    let show = SeasideStarManager.getInstance().isOpen()
    if (self.createIng) {
        return
    }
    self.createIng = true
    if (self.seasideStarBtn) {
        if (!show) {
            self.removeBtnFromSelf(self.seasideStarBtn)
            self.seasideStarBtn = null
        } else {
            self.seasideStarBtn.tryUpdateIcon()
        }
        self.createIng = false
    } else if (show) {
        let onResLoad = function () {
            self.seasideStarBtn = SeasideStarManager.getInstance().createIcon(self)
            self.addBtnToSelf(self.seasideStarBtn, ICON_TYPE.kLeft, "kSeasideStar") //kRight kLeft
            self.createIng = false
        }
        let SeasideStarIcon = require("activity/seasideStar/SeasideStarIcon")
        SeasideStarIcon.preloadRes(onResLoad, () => {
            self.createIng = false
        }, () => {
            self.createIng = false
        });
    }
}
module.exports = HomeSceneBtnLayer
